import { type NodeSpec } from "prosemirror-model";

import { blockquote } from "./blockquote";
import { code_block } from "./code_block";
import { code_snippet } from "./code_snippet";
import { code_snippet_block } from "./code_snippet_block";
import { columns } from "./columns";
import { compute_cell } from "./compute_cell";
import { doc } from "./doc";
import { hard_break } from "./hard_break";
import { heading } from "./heading";
import { horizontal_rule } from "./horizontal_rule";
import { image } from "./image";
import { image_placeholder } from "./image_placeholder";
import { inline_image } from "./inline_image";
import { list_item } from "./list_item";
import { page_link } from "./page_link";
import { paragraph } from "./paragraph";
import { pull_request } from "./pull_request";
import { readonly_section } from "./readonly_section";
import { table } from "./table";
import { table_cell } from "./table_cell";
import { table_header } from "./table_header";
import { table_row } from "./table_row";
import { text } from "./text";
import { text_cell } from "./text_cell";
import { tldraw_embed } from "./tldraw_embed";
import { to_do_item } from "./to_do_item";

export const nodes = {
	doc,
	compute_cell,
	text_cell,
	paragraph,
	blockquote,
	horizontal_rule,
	heading,
	image,
	inline_image,
	image_placeholder,
	code_block,
	text,
	hard_break,
	bullet_list: { ignore: true },
	ordered_list: { ignore: true },
	list_item,
	columns,
	to_do_item,
	code_snippet,
	code_snippet_block,
	pull_request,
	readonly_section,
	tldraw_embed,
	table,
	table_row,
	table_header,
	table_cell,
	page_link,
} as const satisfies Record<string, NodeSpec>;
